import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import themeGet from '@styled-system/theme-get';

import Text from '../../Text';

const HiddenImgCredit = ({ setShowImgCredit }) => {
  const { t } = useTranslation('tiles');

  return (
    <ImageCreditView onClick={() => setShowImgCredit(true)}>
      {t('imageCredit.imageCreditLabel')}
    </ImageCreditView>
  );
};

const VisibleImgCredit = ({ imageCredit, mediaSource }) => {
  const { t } = useTranslation('tiles');

  const unsplashImageCredit = () => {
    const nameAndUrlDivider = '#';
    const divisionIndex = imageCredit.indexOf(nameAndUrlDivider);
    const name = imageCredit.substring(0, divisionIndex);
    const url = imageCredit.substring(divisionIndex + 1);
    return { name, url };
  };

  return (
    <>
      {mediaSource === 'unsplash' ? (
        <ImageCreditView>
          <Text color="white">{t('imageCredit.photoBy')}</Text>
          <CreditLink
            variant="small5"
            as="a"
            href={unsplashImageCredit().url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {unsplashImageCredit().name}
          </CreditLink>{' '}
          <Text color="white">{t('imageCredit.on')}</Text>
          <CreditLink
            variant="small5"
            as="a"
            href="https://unsplash.com/?utm_source=airbo&utm_medium=referral"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('imageCredit.unsplash')}
          </CreditLink>
        </ImageCreditView>
      ) : (
        <ImageCreditView>
          <CreditLink
            variant="small5"
            as="a"
            href={imageCredit}
            target="_blank"
            rel="noopener noreferrer"
          >
            {imageCredit}
          </CreditLink>
        </ImageCreditView>
      )}
    </>
  );
};

const ImageCredit = ({ imageCredit, mediaSource }) => {
  const [showImgCredit, setShowImgCredit] = useState(false);

  return (
    <ImageCreditWrapper>
      {showImgCredit ? (
        <VisibleImgCredit imageCredit={imageCredit} mediaSource={mediaSource} />
      ) : (
        <HiddenImgCredit setShowImgCredit={setShowImgCredit} />
      )}
    </ImageCreditWrapper>
  );
};

HiddenImgCredit.propTypes = {
  setShowImgCredit: PropTypes.func,
};

VisibleImgCredit.propTypes = {
  imageCredit: PropTypes.string,
  mediaSource: PropTypes.string,
};

ImageCredit.propTypes = {
  imageCredit: PropTypes.string,
  mediaSource: PropTypes.string,
};

const ImageCreditWrapper = styled.div`
  font-size: 1em !important;
  max-width: 550px;
  display: block;
  position: absolute;
  bottom: 17px;
  right: 10px;
  font-size: 14px;
  text-align: right;
`;

const ImageCreditView = styled.div`
  font-weight: 600;
  color: ${themeGet('colors.white')};
`;

const CreditLink = styled(Text)`
  cursor: pointer;
  font-size: 14px;
  color: ${themeGet('colors.white')};
`;

export default ImageCredit;
